import ReactGA from 'react-ga';

const googlePageAnalytics = (window) => {
    if (process.env.REACT_APP_IS_PRODUCTION === 'true') {
        ReactGA.pageview(window.location.pathname + window.location.search);
    }
};

export default googlePageAnalytics;
